export default __webpack_public_path__ + "static/media/call-astrologer.aa33913c.png";